'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _FormField = require('./FormField');

var _FormField2 = _interopRequireDefault(_FormField);

var _ScreenReducer = require('../../components/screen/ScreenReducer');

var _FieldEditUpdateAction = require('../../components/screen/actions/FieldEditUpdateAction');

var _FieldEditUpdateAction2 = _interopRequireDefault(_FieldEditUpdateAction);

var _ScreenKeyConst = require('../../components/screen/ScreenKeyConst');

var _SetScreenDataAction = require('../../components/screen/actions/SetScreenDataAction');

var _SetScreenDataAction2 = _interopRequireDefault(_SetScreenDataAction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state, props) {
  var screenKey = (0, _ScreenKeyConst.getScreenKey)(props.screenKey);
  var widget = _react2.default.Children.only(props.children);
  var error = (0, _ScreenReducer.getScreenInvalid)(state.screen, props.path, screenKey);

  return {
    automationName: widget.props.automationName ? widget.props.automationName : props.path[props.path.length - 1],
    value: widget.props.value !== undefined ? widget.props.value : (0, _ScreenReducer.getScreenData)(state.screen, props.path, screenKey),
    invalid: widget.props.invalid !== undefined ? widget.props.invalid : error ? true : false,
    error: error,
    screenKey: screenKey
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
  var screenKey = (0, _ScreenKeyConst.getScreenKey)(props.screenKey);

  return {
    onChange: function onChange(newValue, ignoreDirty) {
      // add hook to allow modifying value when changing before hitting store
      var value = props.modifyOnChange ? props.modifyOnChange(newValue) : newValue;

      if (ignoreDirty) {
        dispatch((0, _SetScreenDataAction2.default)(props.path, value, screenKey));
      } else {
        dispatch((0, _FieldEditUpdateAction2.default)(props.path, value, screenKey));
      }

      // expose after change hook for custom logic
      if (props.onAfterChange) {
        props.onAfterChange(value);
      }
    }
  };
};

var FormFieldContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_FormField2.default);

exports.default = FormFieldContainer;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/formfield/FormFieldContainer.js
// module id = 744
// module chunks = 10